import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import Footer from '../components/Footer';
import BackButton from '../components/BackButton';
import SEO from '../components/SEO';

const RefundPolicyPage: React.FC = () => {
  const { t } = useTranslation('legal');
  const { t: tSeo } = useTranslation('common');

  return (
    <div className='min-h-screen' style={{ background: 'rgb(8 6 20 / 100%)' }}>
      <SEO
        title={tSeo('seo.refund.title')}
        canonical='/refund-policy'
        noIndex={true}
      />
      <Header showUserInfo={false} variant='player' />

      <div className='page'>
        <div className='container-mobile'>
          <BackButton />
          <div className='subtitle'>
            <h1
              style={{
                fontSize: '2.25rem',
                fontWeight: '700',
                color: 'var(--text-primary)',
                fontFamily: 'Lexend Deca, sans-serif',
                marginBottom: '1rem',
              }}
            >
              {t('refunds.title')}
            </h1>
            <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem' }}>
              {t('refunds.lastUpdated')}
            </p>
          </div>

          <div
            style={{
              color: 'var(--text-primary)',
              lineHeight: '1.8',
              fontSize: '1rem',
            }}
          >
            <section style={{ marginBottom: '2rem' }}>
              <h2
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  marginBottom: '1rem',
                  fontFamily: 'Lexend Deca, sans-serif',
                }}
              >
                {t('refunds.section1.title')}
              </h2>
              <p
                style={{ marginBottom: '1rem', color: 'var(--text-secondary)' }}
              >
                {t('refunds.section1.p1')}
              </p>
              <p
                style={{ marginBottom: '1rem', color: 'var(--text-secondary)' }}
              >
                {t('refunds.section1.p2')}
              </p>
              <p style={{ color: 'var(--text-secondary)' }}>
                {t('refunds.section1.p3')}
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  marginBottom: '1rem',
                  fontFamily: 'Lexend Deca, sans-serif',
                }}
              >
                {t('refunds.section2.title')}
              </h2>
              <p
                style={{ marginBottom: '1rem', color: 'var(--text-secondary)' }}
              >
                {t('refunds.section2.p1')}
              </p>
              <p style={{ color: 'var(--text-secondary)' }}>
                {t('refunds.section2.p2')}
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  marginBottom: '1rem',
                  fontFamily: 'Lexend Deca, sans-serif',
                }}
              >
                {t('refunds.section3.title')}
              </h2>

              <h3
                style={{
                  fontSize: '1.2rem',
                  fontWeight: '500',
                  color: 'var(--text-primary)',
                  marginBottom: '0.75rem',
                  marginTop: '1rem',
                }}
              >
                {t('refunds.section3.sub1Title')}
              </h3>
              <p
                style={{ marginBottom: '1rem', color: 'var(--text-secondary)' }}
              >
                {t('refunds.section3.sub1intro')}
              </p>
              <ul
                style={{
                  marginLeft: '2rem',
                  marginBottom: '1rem',
                  color: 'var(--text-secondary)',
                }}
              >
                <li style={{ marginBottom: '0.5rem' }}>{t('refunds.section3.sub1item1')}</li>
                <li style={{ marginBottom: '0.5rem' }}>{t('refunds.section3.sub1item2')}</li>
                <li style={{ marginBottom: '0.5rem' }}>{t('refunds.section3.sub1item3')}</li>
                <li style={{ marginBottom: '0.5rem' }}>{t('refunds.section3.sub1item4')}</li>
                <li>{t('refunds.section3.sub1item5')}</li>
              </ul>

              <h3
                style={{
                  fontSize: '1.2rem',
                  fontWeight: '500',
                  color: 'var(--text-primary)',
                  marginBottom: '0.75rem',
                  marginTop: '1rem',
                }}
              >
                {t('refunds.section3.sub2Title')}
              </h3>
              <p
                style={{ marginBottom: '1rem', color: 'var(--text-secondary)' }}
              >
                {t('refunds.section3.sub2intro')}
              </p>
              <ul
                style={{
                  marginLeft: '2rem',
                  marginBottom: '1rem',
                  color: 'var(--text-secondary)',
                }}
              >
                <li style={{ marginBottom: '0.5rem' }}>{t('refunds.section3.sub2item1')}</li>
                <li style={{ marginBottom: '0.5rem' }}>{t('refunds.section3.sub2item2')}</li>
                <li style={{ marginBottom: '0.5rem' }}>{t('refunds.section3.sub2item3')}</li>
              </ul>
              <p style={{ color: 'var(--text-secondary)' }}>
                {t('refunds.section3.sub2p1')}
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  marginBottom: '1rem',
                  fontFamily: 'Lexend Deca, sans-serif',
                }}
              >
                {t('refunds.section4.title')}
              </h2>
              <p
                style={{
                  marginBottom: '0.5rem',
                  color: 'var(--text-secondary)',
                }}
              >
                {t('refunds.section4.p1')}
              </p>
              <p
                style={{
                  marginBottom: '0.5rem',
                  color: 'var(--text-secondary)',
                }}
              >
                {t('refunds.section4.p2')}
              </p>
              <p
                style={{
                  marginBottom: '0.5rem',
                  color: 'var(--text-secondary)',
                }}
              >
                {t('refunds.section4.p3')}
              </p>
              <p
                style={{
                  marginBottom: '0.5rem',
                  color: 'var(--text-secondary)',
                }}
              >
                {t('refunds.section4.p4')}
              </p>
              <p style={{ color: 'var(--text-secondary)' }}>
                {t('refunds.section4.p5')}
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  marginBottom: '1rem',
                  fontFamily: 'Lexend Deca, sans-serif',
                }}
              >
                {t('refunds.section5.title')}
              </h2>
              <p
                style={{ marginBottom: '1rem', color: 'var(--text-secondary)' }}
              >
                {t('refunds.section5.intro')}
              </p>
              <ul
                style={{
                  marginLeft: '2rem',
                  marginBottom: '1rem',
                  color: 'var(--text-secondary)',
                }}
              >
                <li style={{ marginBottom: '0.5rem' }}>{t('refunds.section5.item1')}</li>
                <li style={{ marginBottom: '0.5rem' }}>{t('refunds.section5.item2')}</li>
                <li style={{ marginBottom: '0.5rem' }}>{t('refunds.section5.item3')}</li>
                <li>{t('refunds.section5.item4')}</li>
              </ul>
              <p
                style={{
                  marginBottom: '0.5rem',
                  color: 'var(--text-secondary)',
                }}
              >
                {t('refunds.section5.p1')}
              </p>
              <p style={{ color: 'var(--text-secondary)' }}>
                {t('refunds.section5.p2')}
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  marginBottom: '1rem',
                  fontFamily: 'Lexend Deca, sans-serif',
                }}
              >
                {t('refunds.section6.title')}
              </h2>
              <p
                style={{
                  marginBottom: '0.5rem',
                  color: 'var(--text-secondary)',
                }}
              >
                {t('refunds.section6.p1')}
              </p>
              <p style={{ color: 'var(--text-secondary)' }}>
                {t('refunds.section6.p2')}
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  marginBottom: '1rem',
                  fontFamily: 'Lexend Deca, sans-serif',
                }}
              >
                {t('refunds.section7.title')}
              </h2>
              <p
                style={{
                  marginBottom: '0.5rem',
                  color: 'var(--text-secondary)',
                }}
              >
                {t('refunds.section7.p1')}
              </p>
              <p style={{ color: 'var(--text-secondary)' }}>
                {t('refunds.section7.p2')}
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  marginBottom: '1rem',
                  fontFamily: 'Lexend Deca, sans-serif',
                }}
              >
                {t('refunds.section8.title')}
              </h2>
              <p
                style={{
                  marginBottom: '0.5rem',
                  color: 'var(--text-secondary)',
                }}
              >
                {t('refunds.section8.p1')}
              </p>
              <p style={{ color: 'var(--text-secondary)' }}>
                {t('refunds.section8.p2')}
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  marginBottom: '1rem',
                  fontFamily: 'Lexend Deca, sans-serif',
                }}
              >
                {t('refunds.section9.title')}
              </h2>
              <p
                style={{ marginBottom: '1rem', color: 'var(--text-secondary)' }}
              >
                {t('refunds.section9.intro')}
              </p>
              <div
                style={{
                  paddingLeft: '1.5rem',
                  color: 'var(--text-secondary)',
                  borderLeft: '3px solid var(--text-secondary)',
                  marginLeft: '1rem',
                }}
              >
                <p style={{ marginBottom: '0.5rem' }}>
                  <strong>{t('refunds.section9.company')}</strong>
                </p>
                <p style={{ marginBottom: '0.5rem' }}>
                  {t('refunds.section9.email')}
                </p>
                <p>{t('refunds.section9.website')}</p>
              </div>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default RefundPolicyPage;
